import { trigger, state, style, transition, animate } from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  state('in', style({
    height: '*',
    opacity: 1
  })),
  state('out', style({
    height: '0px',
    opacity: 0
  })),
  transition('in <=> out', animate('100ms ease-in-out'))
]);

export const slideBoxSit = trigger('slideBoxSit', [
  state('in', style({
    height: '*',
    opacity: 1,
    transform: 'translateY(0)'
  })),
  state('out', style({
    height: '0',
    opacity: 0,
    transform: 'translateY(-100%)'
  })),
  transition('out => in', [
    style({ transform: 'translateY(-100%)' }),
    animate('100ms cubic-bezier(0.17, 0.89, 0.24, 1.11)', style({
      transform: 'translateY(0)',
      opacity: 1,
      height: '*'
    }))
  ]),
  transition('in => out', [
    animate('100ms cubic-bezier(0.6, -0.28, 0.735, 0.045)', style({
      transform: 'translateY(-100%)',
      opacity: 0,
      height: '0'
    }))
  ])
]);
